<template>
  <div
    v-if="user.isAdmin"
    class="adminbar"
    :class="{ help: requestingHelp, open: toggleOpen }"
  >
    <div class="controls" v-show="toggleOpen">
      <div>
        <p>Timer:</p>
        <button v-if="!pageName" @click="startSession">START SESSION</button>
        <button v-else disabled>SESSION STARTED</button>
      </div>

      <div>
        <p>Help:</p>
        <button v-if="!requestingHelp" disabled>NO HELP NEEDED</button>
        <button v-else @click="resetHelp" class="help-btn">DISMISS HELP</button>
      </div>

      <div>
        <p>Pass control ({{ usersList.length }}):</p>
        <select @change="changeController($event)">
          <option disabled>Switch Controller:</option>
          <option
            v-for="user in usersList"
            :key="user.key"
            :selected="user.isController"
            :value="user.key"
          >
            {{ user.name }}
          </option>
        </select>
      </div>

      <div>
        <p>Data:</p>
        <button v-show="!viewData" @click="viewData = true">VIEW</button>
        <button v-show="viewData" @click="viewData = false">HIDE</button>
      </div>
    </div>

    <h1 @click="toggleOpen = !toggleOpen">
      <b>[&nbsp;</b>
      <i>OPERATOR</i>
      <b>&nbsp;]</b>
    </h1>

    <div v-if="viewData" class="data">
      <h2>DATA</h2>
      <h3>
        Session: [axis:{{ $store.state.session.axis }}] [id:{{
          $store.state.session.id
        }}]
      </h3>
      <h3>Scenario: {{ scenario.name }}</h3>
      <h3>Approach: {{ $store.state.side }}</h3>
      <h3>Register: [&nbsp;{{ register }}&nbsp;]</h3>
      <h3>Task: {{ $store.getters.task }}</h3>
      <h3>Difficulty: {{ $store.state.difficulty }}</h3>
      <h3>
        Archetype:
        <b
          >[0{{ $store.getters.selectedArchetype.index }}]&nbsp;{{
            $store.getters.selectedArchetype.title
          }},</b
        >
        &nbsp;{{ $store.getters.selectedArchetype.text }}
      </h3>

      <h3>
        Role:
        <b
          >[0{{ $store.getters.selectedRole.index }}]&nbsp;{{
            $store.getters.selectedRole.title
          }},</b
        >
        &nbsp;{{ $store.getters.selectedRole.text }}
      </h3>
      <h3>Vision: {{ $store.state.visionText }}</h3>
      <h3>Motivation: {{ $store.state.motivationText }}</h3>
      <h3>Aim: {{ $store.state.objectiveText }}</h3>
      <h3>Target: {{ $store.state.targetText }}</h3>
      <h3>Method: {{ $store.state.methodText }}</h3>
      <h3>Impact: {{ $store.state.impactText }}</h3>
      <h3>Questionnaire</h3>
      <ol>
        <li v-for="(a, index) in $store.state.feedback" :key="index">
          {{ feedbackOptions[a - 1] }}
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import feedbackJson from "../data/feedback.json";
import { mapState, mapGetters } from "vuex";

export default {
  data: function () {
    return {
      viewData: false,
      toggleOpen: true,
    };
  },
  computed: {
    register() {
      var s = "";
      var sortedKeys = Object.keys(this.$store.state.usersObj).sort();

      // Loop through the users in order
      var key;

      for (var i = 0; i < sortedKeys.length; i++) {
        // Store current key
        key = sortedKeys[i];

        // Populate the list array with each user's data
        s += this.$store.state.usersObj[key].name;
        if (i < sortedKeys.length - 1) {
          s += ", ";
        }
      }
      return s;
    },
    feedbackOptions() {
      return feedbackJson.feedbackOptions;
    },
    ...mapGetters(["usersList"]),
    ...mapState(["user", "requestingHelp", "pageName", "usersObj", "scenario"]),
  },
  methods: {
    startSession() {
      // send 'timer' to the RTDB which will be sent to everyone
      this.$store.state.sessionRef.update({
        pageName: "timer",
      });
    },
    changeController(event) {
      var x = confirm(
        "Pass control to " + this.usersObj[event.target.value].name
      );
      if (x) {
        this.$store.dispatch("switchControllerTo", event.target.value);
      }
    },
    resetHelp() {
      var x = confirm("Dismiss help for everyone");
      if (x) {
        // remove requestingHelp from the DB
        this.$store.state.sessionRef.update({
          requestingHelp: false,
        });
      }
    },
  },
};
</script>

<style lang="scss">
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}

.adminbar {
  position: fixed;
  top: 0px;
  right: 0px;
  // width: 100%;
  height: 84px;
  padding: 20px;
  background-color: rgba($color: #000000, $alpha: 1);
  color: white;
  z-index: 9999;
  display: flex;
  justify-content: space-between;

  &.help {
    background-color: orangered;

    .help-btn {
      animation: flickerAnimation 2s infinite;
    }
  }

  &.open {
    width: 100%;
  }

  h1 {
    display: inline-block;
    cursor: pointer;
  }

  .controls {
    display: flex;

    > div {
      margin: 0 20px 0 20px;
    }

    button,
    select {
      cursor: pointer;

      color: black;
      background: white;
      border: none;
      padding: 5px 5px 3px 5px;

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }

  .data {
    position: absolute;
    top: 84px;
    left: 0px;
    width: 100%;
    height: 100vh;
    padding: 0 50% 0 20px;
    overflow: scroll;
    background-color: rgba($color: #000000, $alpha: 0.7);
    z-index: 99;
  }
}
</style>      
        